module.exports = __webpack_public_path__ + "static/img/20.79b5880f.png";